export const CadenceUnits = Object.freeze({
  TIME: 'time',
  DAYS: 'days',
  WEEKS: 'weeks',
  MONTHS: 'months',
  YEARS: 'years'
})
